import React from "react";

const ViewApplication = () => {
  return (
    <div>
      <h1>View Applications</h1>
      <p>Here you can view and manage student applications.</p>
      {/* Add more functionality as needed */}
    </div>
  );
};

export default ViewApplication;
